import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React, { useMemo } from 'react';
import { version } from '../package.json';

const getEnvironment = (url) => {
  try {
    if (url.includes('app.trialbee.com')) {
      return 'preview';
    } else if (url.includes('trialbee.com')) {
      return 'production';
    } else if (url.includes('stage.trialbee.xyz')) {
      return 'stage';
    } else if (url.includes('dev.trialbee.xyz')) {
      return 'dev';
    } else if (url.includes('local.trialbee.xyz')) {
      return 'local';
    }
  } catch (_) {}
  return 'unknown';
};

export const startBugSnag = (config) => {
  const { studyId, locale, baseURI, landingPage } = config;

  Bugsnag.start({
    apiKey: process.env.BUGSNAG_API_KEY || '2da0f97bc911d81177881caf1438a7e0',
    plugins: [new BugsnagPluginReact()],
    releaseStage: getEnvironment(window.location.hostname),
    enabledReleaseStages: ['production', 'stage', 'dev', 'unknown', 'preview'],
    appType: 'react',
    appVersion: version || 'unknown',
    metadata: { baseURI, studyId, locale, landingPage, version },
  });
};

export const notifyError = ({ error, body }) => {
  Bugsnag.notify(error, { request: body });
};

export function ErrorBoundary(props) {
  const ReactErrorBoundary = useMemo(
    () => Bugsnag.getPlugin('react').createErrorBoundary(React),
    [Bugsnag, React],
  );

  return <ReactErrorBoundary {...props} />;
}
